import { render } from "./InventoryReportsPage.vue?vue&type=template&id=9b8d9ee2&ts=true"
import script from "./InventoryReportsPage.vue?vue&type=script&lang=ts"
export * from "./InventoryReportsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__